import { render, staticRenderFns } from "./ProfileCourier.vue?vue&type=template&id=0029fe45&"
import script from "./ProfileCourier.vue?vue&type=script&lang=js&"
export * from "./ProfileCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports